import { Button, DateTimePicker, FormCheckbox, Modal, ModalCloseButton, ModalFooter, ModalHeader, NotificationDispatch } from '@tryhackme/thm-ui-components';
import { parseISO, subDays } from 'date-fns';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'src/common/form';
import { isQueryErrorWithMessage } from 'src/common/helpers/slices';
import { useGetSingleCompanyQuery, useUpdateDeadlineMutation } from '../../corporate.slice';
import { CorpSideButton, StyledButtonIcon } from '../../corporate.styles';
import type { BaseModalProps, UpdateDeadlineData } from '../../corporate.types';
import { StyledModalTitle, StyledTextField } from '../add-seat-modal/add-seat-modal.styles';
import { StyleFormLabel } from './update-plan-modal.styles';
export const UpdatePlanModal = ({
  companyId,
  icon
}: BaseModalProps) => {
  const {
    data: companyData
  } = useGetSingleCompanyQuery({
    companyId
  });
  const [updateDeadline] = useUpdateDeadlineMutation();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const handleModalClose = () => {
    setModalOpen(false);
  };
  const {
    getValues,
    reset,
    handleSubmit,
    control,
    setValue
  } = useForm<Pick<UpdateDeadlineData, 'isTrial'> & {
    deadline: Date | null;
  }>();
  useEffect(() => {
    const deadline = companyData?.data?.companyDetails.deadline;
    const isTrial = companyData?.data?.companyDetails.isTrial;
    setValue('deadline', deadline ? parseISO(deadline) : null);
    setValue('isTrial', isTrial ?? false);
  }, [companyData?.data?.companyDetails.deadline, companyData?.data?.companyDetails.isTrial, setValue]);
  const onSubmit = async () => {
    try {
      const {
        isTrial,
        deadline
      } = getValues();
      await updateDeadline({
        companyId,
        deadline: deadline?.toISOString() ?? '',
        isTrial
      }).unwrap();
      NotificationDispatch('success', 'Deadline Updated successfully');
    } catch (error) {
      NotificationDispatch('error', isQueryErrorWithMessage(error) ? error.data.message : 'An unknown error has occurred');
    }
    reset();
    handleModalClose();
  };
  return <Modal onOpenChange={open => setModalOpen(open)} open={modalOpen} overflowVisible preventOnOpenAutoFocus triggerElement={<CorpSideButton color="secondary" variant="outlined">
          <StyledButtonIcon icon={icon} size="lg" />
          Update deadline date
        </CorpSideButton>} isSmall data-sentry-element="Modal" data-sentry-component="UpdatePlanModal" data-sentry-source-file="update-plan-modal.tsx">
      <ModalHeader isSmall data-sentry-element="ModalHeader" data-sentry-source-file="update-plan-modal.tsx">
        <StyledModalTitle isSmall data-sentry-element="StyledModalTitle" data-sentry-source-file="update-plan-modal.tsx">Update deadline date</StyledModalTitle>
      </ModalHeader>

      {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
      <form id="update-plan" method="dialog" onSubmit={handleSubmit(onSubmit)}>
        <StyledTextField data-sentry-element="StyledTextField" data-sentry-source-file="update-plan-modal.tsx">
          <Controller name="deadline" control={control} render={({
          field: {
            value,
            ref,
            ...rest
          }
        }) => <DateTimePicker {...rest} label="Deadline date" placeholderText="None selected" minDate={subDays(new Date(), 30)} timeIntervals={15} isClearable shouldCloseOnSelect autoComplete="off" required selected={value} />} data-sentry-element="Controller" data-sentry-source-file="update-plan-modal.tsx" />
        </StyledTextField>
        <Controller name="isTrial" control={control} render={({
        field: {
          value,
          onChange,
          ref,
          ...rest
        }
      }) => <StyleFormLabel>
              <FormCheckbox innerRef={ref} checked={value} onCheckedChange={state => onChange(state)} {...rest} />
              This is a trial
            </StyleFormLabel>} data-sentry-element="Controller" data-sentry-source-file="update-plan-modal.tsx" />
        <ModalFooter isSmall data-sentry-element="ModalFooter" data-sentry-source-file="update-plan-modal.tsx">
          <ModalCloseButton text="Cancel" handleCloseButtonAction={() => reset()} data-sentry-element="ModalCloseButton" data-sentry-source-file="update-plan-modal.tsx" />
          <Button type="submit" color="primary" variant="solid" data-sentry-element="Button" data-sentry-source-file="update-plan-modal.tsx">
            Update Date
          </Button>
        </ModalFooter>
      </form>
    </Modal>;
};